import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class LoginService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    login(login) {
        const body = JSON.stringify(login);
        return this.http.post(`${this.configService.PUB_URL}/authentication/user`, body, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    obtenerMenuUsuario() {
        let headerContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'User': sessionStorage.getItem('userid') != null ? sessionStorage.getItem('userid') : '0'
            })
        };
        return this.http.get(`${this.configService.PUB_URL}/menu/user`, Object.assign({}, headerContent, { responseType: 'json' })).toPromise();
    }
    obtenerPermisosMenu(menu) {
        let headerContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'User': sessionStorage.getItem('userid') != null ? sessionStorage.getItem('userid') : '0'
            })
        };
        return this.http.get(`${this.configService.PUB_URL}/menu/user/${menu}/permisos`, Object.assign({}, headerContent, { responseType: 'json' })).toPromise();
    }
    getkeyWord() {
        let headerContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        };
        return this.http.get(`${this.configService.PUB_URL}/access/validation`, Object.assign({}, headerContent, { responseType: 'json' })).toPromise();
    }
}
LoginService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: LoginService, providedIn: "root" });
